import { Loader2 } from "lucide-react";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

export const Spinner = ({ className, ...props }: HTMLAttributes<SVGSVGElement>) => (
  <Loader2 className={cn("h-6 w-6 animate-spin text-primary", className)} {...props} />
);
